<canvas
  #canvas
  id="canvas"
  (window:resize)="onResize()"
  [width]="width"
  [height]="height"
></canvas>
<div #overlay class="overlay">
  <div class="max-win">Max bet: $50 | Max win: $5000</div>
  <div
    #multipliers
    class="multipliers"
    [style.gap.px]="pegRadius"
    [style.--space.px]="(elementWidth / width) * firstPegX()"
  >
    @for (multiplier of plinkoService.currentMultipliers(); track $index; let
    index = $index) {
    <div
      class="multiplier t{{ multiplier.tier }} pocket{{ index }}"
      [class.alt]="elementWidth < 700 && plinkoService.currentRows() > 12"
    >
      <div
        [ngpTooltipTrigger]="chanceTooltip"
        [ngpTooltipTriggerHideDelay]="0"
        [ngpTooltipTriggerOffset]="-5"
        class="number"
      >
        x{{ multiplier.multiplier | number : "1.0-2" }}
      </div>
      <ng-template #chanceTooltip>
        <div class="tooltip pb-tooltip" ngpTooltip>
          <div class="pb-tooltip--item">
            <span class="pb-tooltip--title">Chance:</span>
            <span
              class="pb-tooltip--value"
              [class.t1]="multiplier.tier === 1"
              [class.t2]="multiplier.tier === 2"
              [class.t3]="multiplier.tier === 3"
            >
              {{ multiplier.chance.toFixed(3) }}%
            </span>
          </div>
        </div>
      </ng-template>
    </div>
    }
  </div>
  <div class="history">
    @for (i of history(); track $index) {
    <div
      class="item t{{ i.multiplier.tier }}"
      [ngpTooltipTrigger]="historyTooltip"
      [ngpTooltipTriggerHideDelay]="0"
    >
      x{{ i.multiplier.multiplier | number : "1.0-2" }}
      <ng-template #historyTooltip>
        <div class="tooltip pb-tooltip" ngpTooltip>
          <div class="pb-tooltip--item">
            <span class="pb-tooltip--title">Ticket:</span>
            <span class="pb-tooltip--value">
              {{ i.result.ticket }}
            </span>
          </div>
          <div class="pb-tooltip--item">
            <span class="pb-tooltip--title">Nonce:</span>
            <span class="pb-tooltip--value">
              {{ i.result.nonce }}
            </span>
          </div>
          <div class="pb-tooltip--item">
            <span class="pb-tooltip--title"> Value: </span>
            <app-cost
              [gap]="4"
              [balanceType]="session.balanceType()"
              [cost]="i.result.winningValue"
            />
          </div>
        </div>
      </ng-template>
    </div>
    }
  </div>
</div>
